import React from 'react';
import Helmet from 'react-helmet';

import Layout from '../components/layout';
import Static from '../components/static';
import A from '../components/a';
import Heading from '../components/heading';

const SiteMapSection = ({ headerText, headerHref, links }) => (
    <div>
        <h4><A headerLink href={headerHref}>{headerText}</A></h4>
        <ul css={{ paddingLeft: 24 }}>
            {links.map(({ text, href }) => <li><A href={href}>{text}</A></li>)}
        </ul>
    </div>
);

export default ({ location: { pathname } }) => (
    <Layout pathname={pathname}>
        <Static>
            <Helmet title="Site Map" meta={[{ property: 'og:title', content: 'Site Map' }]} />
            <Heading>Site Map</Heading>
            <div
                css={{
                    display: 'grid',
                    gridGap: 16,
                    gridTemplateColumns: 'repeat(auto-fill, minmax(220px,1fr))',
                }}
            >
                <SiteMapSection
                    headerText="Walletwyse"
                    headerHref="/"
                    links={[
                        { text: 'About', href: '/about' },
                        { text: 'Terms and Conditions', href: '/terms-and-conditions"' },
                        { text: 'Site Map', href: '/site-map' }
                    ]}
                />
                <SiteMapSection
                    headerText="Calculators"
                    headerHref="/calculators"
                    links={[
                        { text: 'Home Purchase Calculator', href: '/calculators/home' },
                        { text: 'Car Purchase Calculator', href: '/calculators/car' },
                        { text: 'Investment Calculator', href: '/calculators/investment' },
                        { text: 'Terms & Knowledge', href: '/terms-and-knowledge' }
                    ]}
                />
                <SiteMapSection
                    headerText="Homes"
                    headerHref="/category/homes"
                    links={[
                        { text: 'Home Purchase Calculator', href: '/calculators/home' },
                        { text: 'Home Purchase Articles', href: '/articles/home' },
                        { text: 'Home Purchase Wyse Awards', href: '/wyse-awards/home' },
                        { text: 'Terms & Knowledge', href: '/terms-and-knowledge' }
                    ]}
                />
                <SiteMapSection
                    headerText="Cars"
                    headerHref="/category/cars"
                    links={[
                        { text: 'Car Purchase Calculator', href: '/calculators/car' },
                        { text: 'Car Purchase Articles', href: '/articles/car' },
                        { text: 'Car Purchase Wyse Awards', href: '/wyse-awards/car' },
                        { text: 'Terms & Knowledge', href: '/terms-and-knowledge' }
                    ]}
                />
                <SiteMapSection
                    headerText="Investments"
                    headerHref="/category/investments"
                    links={[
                        { text: 'Investment Calculator', href: '/calculators/investment' },
                        { text: 'Investment Articles', href: '/articles/investment' },
                        { text: 'Investment Wyse Awards', href: '/wyse-awards/investment' },
                        { text: 'Terms & Knowledge', href: '/terms-and-knowledge' }
                    ]}
                />
                <SiteMapSection
                    headerText="Articles"
                    headerHref="/articles"
                    links={[
                        { text: 'Home Purchase Articles', href: '/articles/home' },
                        { text: 'Car Purchase Articles', href: '/articles/car' },
                        { text: 'Investment Articles', href: '/articles/investment' },
                        { text: 'Lifestyle Articles', href: '/articles/lifestyle' },
                        { text: 'Terms & Knowledge', href: '/terms-and-knowledge' }
                    ]}
                />
                <SiteMapSection
                    headerText="Awards"
                    headerHref="/wyse-awards"
                    links={[
                        { text: 'Home Purchase Wyse Awards', href: '/articles/home' },
                        { text: 'Car Purchase Wyse Awards', href: '/articles/car' },
                        { text: 'Investment Wyse Awards', href: '/articles/investment' },
                        { text: 'Lifestyle Wyse Awards', href: '/wyse-awards/lifestyle' },
                        { text: 'Travel Wyse Awards', href: '/wyse-awards/travel' },
                        { text: 'Terms & Knowledge', href: '/terms-and-knowledge' }
                    ]}
                />
            </div>
        </Static>
    </Layout>
);
